// This will be the side navBar of the physics section

import React from 'react';
import {List, ListItem} from 'material-ui/List';
import ContentInbox from 'material-ui/svg-icons/content/inbox';
import ActionGrade from 'material-ui/svg-icons/action/grade';
import ContentSend from 'material-ui/svg-icons/content/send';
import ContentDrafts from 'material-ui/svg-icons/content/drafts';
import Divider from 'material-ui/Divider';
import ActionInfo from 'material-ui/svg-icons/action/info';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import { Scrollbars } from 'react-custom-scrollbars';

export default class PhysicsMenu extends React.Component {



  render(){

    return(

  <MuiThemeProvider>


    <List style = {{padding: 0, paddingRight: 20}}>
    <Link style = {{color: 'black'}} to = "/physics"> <ListItem> AAMC Requirements </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/translationalmotion">  <ListItem> Translational Motion </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/force">  <ListItem> Force </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/work">  <ListItem> Work </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/energy">  <ListItem> Energy </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/periodicmotion">  <ListItem> Periodic Motion </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/fluids">  <ListItem> Fluids </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/thermodynamics">  <ListItem> Thermodynamics </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/electrostatics">  <ListItem> Electrostatics </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/circuits">  <ListItem> Circuits </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/magnetism">  <ListItem> Magnetism </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/sound">  <ListItem> Sound </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/light">  <ListItem> Light </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/optics">  <ListItem> Optics </ListItem> </Link>
      <Divider />
    <Link style = {{color: 'black'}} to = "/physics/atomicnucleus">  <ListItem> Atomic Nucleus </ListItem> </Link>
      <Divider />
      <ListItem> More coming soon </ListItem>
      <Divider />

    </List>

  </MuiThemeProvider>
);


}

}



// WEBPACK FOOTER //
// ./src/Physics/PhysicsMenu.js